import { render, staticRenderFns } from "./ClusterList.vue?vue&type=template&id=63349ffe&scoped=true&"
import script from "./ClusterList.vue?vue&type=script&lang=ts&"
export * from "./ClusterList.vue?vue&type=script&lang=ts&"
import style0 from "./ClusterList.vue?vue&type=style&index=0&id=63349ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63349ffe",
  null
  
)

export default component.exports